import { Link } from "react-router-dom";
import { Smartphone } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { AppStoreButtons } from "@/components/AppStoreButtons";

export default function GetAppDialog({ feature, onClose }) {
  return (
    <Dialog open={!!feature} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="get-app-dialog">
        <DialogHeader className="text-center sm:text-center">
          <div className="mx-auto mb-3 w-12 h-12 rounded-full bg-accent/10 flex items-center justify-center">
            <Smartphone className="w-6 h-6 text-accent" />
          </div>
          <DialogTitle className="font-serif text-xl" data-testid="get-app-dialog-title">
            {feature} is in the app
          </DialogTitle>
          <DialogDescription className="text-base">
            Download DIY Fly Fishing to save favorites, drop waypoints, keep a trip journal, use maps offline and read full river reports.
          </DialogDescription>
        </DialogHeader>
        <AppStoreButtons idPrefix="get-app-dialog-" className="justify-center" />
        <p className="text-sm text-muted-foreground text-center">
          Already a member? Sign in to the app with your membership email.{" "}
          <Link to="/app" onClick={onClose} className="text-accent hover:underline" data-testid="get-app-dialog-learn-more">
            Learn more
          </Link>
        </p>
      </DialogContent>
    </Dialog>
  );
}
